export default __webpack_public_path__ + "static/media/workspace_adnan.9d1dd635.jpg";